<template>
  <div class="zj-layout-main">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ZjLayoutMain'
}
</script>
